import React from 'react';
import '../../../../../styles/components/project-card.scss'
import { Spinner } from 'react-bootstrap';


class DashboardCard extends React.Component {
    render() {
        const { icon: Icon, className, title, value, onClick , dd_loading} = this.props;

        return (
            <div
                className={`project-card ${className}`}
                onClick={onClick}
                style={{ cursor: onClick ? 'pointer' : 'default' }}
            >
                <div className="project-card-body">
                    <div className={`project-card-icon ${className}`}>
                        <Icon size={24} />
                    </div>
                    <div className="project-card-text">
                        <div className="project-header">
                            {title}</div>
                        <div className="project-value">{dd_loading &&  (
                            <Spinner animation="grow" size="sm" />
                        )}{value}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DashboardCard;
